module.exports = __webpack_public_path__ + "img/nolan-versions.c953acc2.svg";